import type { HomePage } from '../model/HomePage';

export const Admin: HomePage = {
    name: 'Admin',
    widgets: [ 'Tenants', 'Automations', 'Runs', 'Actions' ],
    featureFlag: 'HomePage-Admin',
    persona: 'ADMIN',
};
